import { differenceInDays } from 'date-fns';

/**
 * Calcola i giorni rimanenti fino alla scadenza
 * Valori negativi indicano giorni trascorsi dalla scadenza
 * 
 * @param dataScadenza - Data di scadenza in formato string
 * @returns Numero di giorni (negativo se scaduto, 0 se scade oggi, positivo se futuro)
 */
export const getDaysUntilExpiry = (dataScadenza: string): number => {
  const scadenzaDate = new Date(dataScadenza);
  const today = new Date();
  
  // Normalizza le ore per comparare solo le date (senza ore/minuti/secondi)
  scadenzaDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  
  // Verifica se la data è valida e non troppo nel passato (prima del 2000)
  if (isNaN(scadenzaDate.getTime()) || scadenzaDate.getFullYear() < 2000) {
    return 0; // Tratta come scaduta oggi se la data è invalida
  }
  
  return differenceInDays(scadenzaDate, today);
};

/**
 * Ottiene il testo di display per i giorni rimanenti/trascorsi
 * 
 * @param days - Numero di giorni (da getDaysUntilExpiry)
 * @returns Stringa formattata per il display
 */
export const getDaysDisplayText = (days: number): string => {
  if (days < 0) return `Scaduto ${Math.abs(days)}gg fa`;
  if (days === 0) return 'Scade oggi';
  return `${days} giorni`;
};

/**
 * Ottiene il colore del chip in base ai giorni rimanenti
 * 
 * @param days - Numero di giorni (da getDaysUntilExpiry)
 * @returns Colore del chip MUI
 */
export const getDaysChipColor = (days: number): 'error' | 'warning' | 'info' => {
  if (days < 0) return 'error';
  if (days === 0) return 'error';
  if (days <= 3) return 'warning';
  if (days <= 7) return 'warning';
  return 'info';
};

/**
 * Ottiene il colore del testo in base ai giorni rimanenti
 * 
 * @param days - Numero di giorni (da getDaysUntilExpiry)
 * @returns Colore del testo MUI
 */
export const getDaysTextColor = (days: number): string => {
  if (days < 0) return 'error.main';
  if (days === 0) return 'error.main';
  if (days <= 3) return 'warning.main';
  if (days <= 7) return 'warning.main';
  return 'text.primary';
};